import React, { useRef, useMemo } from 'react';
import { useGLTF } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';

// Extracted Model component using useGLTF
function ModelComponent(props) {
  // Mobile detection
  const isMobile = useMemo(() => {
    if (typeof window !== 'undefined') {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    }
    return false;
  }, []);

  // Use the Kapsel model for both desktop and mobile
  const modelPath = '/models/sy3_kapsel.glb';
  
  // Make sure the path is correct relative to the public folder
  const { scene } = useGLTF(modelPath);
  const modelRef = useRef();

  // Auto-rotation logic
  useFrame((state, delta) => {
    if (modelRef.current) {
      // Slower rotation speed for better viewing
      modelRef.current.rotation.y += delta * 0.2; 
    }
  });

  // Apply passed props (like position, scale, rotation)
  return <primitive ref={modelRef} object={scene} {...props} />;
}

// Preload the Kapsel model
useGLTF.preload('/models/sy3_kapsel.glb');

export default ModelComponent; 